import { useSortable } from "@dnd-kit/sortable";
import { DeleteRedIcon, DragIcon, EditIcon } from "../../../assets/icons";
import { SubcategorySettingsListItemDTO } from "../../../models/subcategories/subcategories.response";
import { CSS } from "@dnd-kit/utilities";


type SortableRowProps = {
    subcategory: SubcategorySettingsListItemDTO;
    onEdit: (id: string) => void;
    onDelete: (id: string) => void;
};

const SortableSubcategoryRow: React.FC<SortableRowProps> = ({ subcategory, onEdit, onDelete }) => {

    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: subcategory.id,
    });

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.85 : 1,
    };

    return (
        <div className="list-row-div subcategory-row" ref={setNodeRef} style={style}>
            <img id="w-node-_784b75b9-7580-94fe-59b3-83eda5076a22-1cee91cf" loading="lazy" alt="" src={DragIcon} className="image-4"
                style={{ cursor: "grab" }}
                {...attributes}
                {...listeners}
            />

            <div>{subcategory.name}</div>
            <div className="small-box-div">
                <div className="text-block-9">{subcategory.categoryName}</div>
            </div>
            <div>{subcategory.slug}</div>

            {subcategory.isDeleted ? (
                <div className="small-box-div grey-bg">
                    <div className="category-list-div-row-status">Neaktivna</div>
                </div>
            ) : (
                <div className="small-box-div green-bg">
                    <div className="category-list-div-row-status">Aktivna</div>
                </div>
            )}

            <div id="w-node-_784b75b9-7580-94fe-59b3-83eda5076a2d-1cee91cf" className="table-row-action-btns-div">
                <img loading="lazy" src={EditIcon} alt="" className="category-list-div-row-actions-image"
                    onClick={() => {
                        onEdit(subcategory.id);
                    }} />
                <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image"
                    onClick={() => {
                        onDelete(subcategory.id);
                    }} />
            </div>
        </div>
    )
};

export default SortableSubcategoryRow;